import { render } from "./ChildrenLayout.vue?vue&type=template&id=4afb6c01"
import script from "./ChildrenLayout.vue?vue&type=script&lang=js"
export * from "./ChildrenLayout.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__